import { parseHTML } from "../../../Utils/common.utils";
import AuctionCard from "../auction-card/auction-card.component";
import { AUCTION_TYPE } from "../auction-status/auction-status.component";
import {
  CMAuctionCard,
  CMAuctionItem,
  CMDivider,
  CMCarouselContainer,
  CMAuctionDescription,
} from "./auction-item.styles";
import AuctionMetrics from "../auction-metrics/auction-metrics.component";
import AuctionCarousel, {
  AUCTION_CAROUSEL_TYPE,
  imgBreakpoints,
} from "../auction-carousel/auction-carousel.component";
import { useMediaQuery } from "@mui/material";
import Spotify from "../../spotify-icon/spotify-icon.component";
import Ellipsis from "../../ellipsis/ellipsis.component";
import SocialMediaShare from "../../social-media/social-media-share.component";
import { CMSlide } from "../../../Pages/Public/auction-details/AuctionDetails";
import YoutubeEmbed from "../../youtube-embed/youtube-embed.component";


const isValidUrl = (url) => {
  try {
    new URL(url);
    return true;
  } catch (e) {
    console.error("Formato de URL inválido:", e);
    return false;
  }
};


const AuctionItem = ({ auction, position }) => {
  const isMobile = useMediaQuery("(max-width:992px)");

  const extractPlainText = (JSONText, first = false) => {

      let texts = [];

      try {
        let json = first ? JSON.parse(JSONText) : JSONText
        json.forEach(item => {
          if (item.text) {
            texts.push(item.text);
          }
          if (item.children) {
            texts = texts.concat(extractPlainText(item.children));
          }
        });
      }
      catch (e) {
        return null
      }

      return texts;
  }

  return (
    <CMAuctionItem
      className={`${auction.status}-item ${isMobile ? "mobile" : ""}`}
    >
      <div>
        <CMCarouselContainer>
          {isMobile &&
          (auction.status === AUCTION_TYPE.progress.id ||
            auction.status === AUCTION_TYPE.upcoming.id ||
            auction.status === AUCTION_TYPE.scheduled.id) ? (
            <AuctionCard auction={auction} cardType={AUCTION_TYPE.mobile.id} />
          ) : (
            <AuctionCarousel
              slides={auction.imgSrc || [""]}
              carouselType={AUCTION_CAROUSEL_TYPE.imageSemiRounded}
              breakpoints={imgBreakpoints}
              auctionID={auction.auctionID}
            />
          )}
        </CMCarouselContainer>
        <CMAuctionDescription>
          <SocialMediaShare url={`${window.location.origin}/auctions-board/auction?id=${auction.auctionID}`} auctionName={auction?.title} isWatch={auction?.IsWatch} auctionID={auction?.auctionID}/>
          <h4>{auction.title.split('/').pop().trim()}</h4>
          <span>{auction.listingType}</span>
          <Ellipsis
            text={extractPlainText(auction.description, true) ? extractPlainText(auction.description, true).join(' \n ') : auction.description}
            limit={150}
            tail={"more..."}
            style={{ wordBreak: "break-word" }}
            redirect={true}
            src={`/auctions-board/auction?id=${auction?.auctionID}&expand`}
          />
          <AuctionMetrics
              spotify={
                auction.spotifyMonthlyListeners
              }
              spotifyChannel={
                auction.spotifyChannel
              }
              instagram={
                auction.instagramMonthlyListeners
              }
              instagramChannel = { 
                auction.instagramChannel 
              }
              youtube={
                auction.youtubeMonthlyListeners
              }
              youtubeChannel={
                auction.youtubeChannel
              }      
              facebook={
                auction.facebookMonthlyListeners
              }
              facebookChannel={
                auction.facebookChannel
              }        
            />

          {auction && auction.status === AUCTION_TYPE.scheduled.id ? (
            <Spotify spotifyLink={auction.spotifyLink} />
          ) : (
            ""
          )}
        </CMAuctionDescription>

        <CMAuctionCard>
          <AuctionCard auction={auction} cardType={auction.status} />
          {auction &&
          (auction.status === AUCTION_TYPE.scheduled.id ||
            auction.status === AUCTION_TYPE.upcoming.id ||
            auction.status === AUCTION_TYPE.progress.id) ? (
            <AuctionMetrics
              className="MetricsResponsiveHide"
              spotify={auction?.metrics?.spotify}
              instagram={auction?.metrics?.instagram}
            />
          ) : (
            ""
          )}
        </CMAuctionCard>
      </div>

      {auction && auction?.videos && auction?.videos.length !== 0 && (
         <CMSlide style={{display: "flex", flexDirection:"row"}}>
         {auction?.videos && auction?.videos.map((videos, index) =>
          <div>
            {videos?.link && typeof videos?.link === 'string' && videos?.link !== "" &&
              <YoutubeEmbed
                  key={index}
                  source={videos?.link}
                  thumbnail={videos?.thumbnail}
                  width={176}
                  height={100}
                  auctionID={auction?.auctionID}
                />
            }
          </div>
         )}
         {auction?.spotifyLink && isValidUrl(auction?.spotifyLink) && (
           <YoutubeEmbed
             source={auction?.spotifyLink}
             width={176}
             height={100}
             auctionID={auction?.auctionID}
           />
         )}
       </CMSlide>
      )}

      {position && position > 0 ? <CMDivider className="dotted-border" /> : ""}
    </CMAuctionItem>
  );
};

export default AuctionItem;
